<template>
  <div class="iframe-covid">
    <input type="text" v-model="locationText" @focus="displayListLocations = true, $emit('onFocusSearch')"
      @keyup="locationInput()" ref="locationInputRef" @focusout="focusOutLocationInput()" class="input-where"
      :placeholder="placeholder" aria-label="Précisez votre ville" />
    <div class="iframe-covid-list-btns">
      <button v-if="locationText" @click="locationText = ''" type="button" class="clear-item-search btn-close">
        <i class="icon-close-circle-solid" aria-hidden="true"></i>
        <span class="sr-only">Supprimer</span>
      </button>
      <button aria-label="Rechercher" class="iframe-covid__btn-search iframe-covid-btn"
        @click.prevent="$emit('onSearch', { locationText })" :disabled='locationText?.length > 0 && locationText?.length < 3'>
        <i class="icon-search" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <WhereAutoComplete class="iframe-covid__where-input" :isAbsolute="false"
    :locationListHistoyFiltred="locationListHistoyFiltred" @onClearLocationHistory="$emit('onClearLocationHistory')"
    @onRemoveLocationItem="$emit('onRemoveLocationItem', $event)" :displayListLocations="displayListLocations"
    :locationListApi="locationListApi" @onClickLocationText="locationText = $event" />
</template>
<script>
import { ref, computed } from 'vue';
import WhereAutoComplete from '@/components/homePage/autoCompleteComponents/WhereAutoComplete.component.vue';
import { debounce } from '@/helpers';
import iframeCovidService from '@/services/iframeCovid';

export default {
  components: {
    WhereAutoComplete,
  },
  props: {
    locationListApi: {
      type: Array,
      default: () => [],
    },
    locationListHistory: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['onFocusSearch', 'onLocationinput'],
  setup(props, { emit }) {
    const locationText = ref('');
    const displayListLocations = ref(false);
    const locationListHistoyFiltred = computed(() => (locationText.value.length < 3 ? props.locationListHistory : []));

    const locationInput = debounce(() => {
      emit(
        'onLocationinput',
        locationText.value.length > 2 ? locationText.value : null,
      );
    });
    const focusOutLocationInput = debounce(() => {
      displayListLocations.value = false;
    });
    const placeholder = iframeCovidService.getPlaceholder();
    return {
      locationText,
      displayListLocations,
      locationInput,
      focusOutLocationInput,
      placeholder,
      locationListHistoyFiltred,
    };
  },
};
</script>
